<div class="modal right" id="stockStoreDetail" tabindex="-1" role="dialog" aria-labelledby="stockStoreDetailLabel">
	<div class="modal-dialog modal-lg" role="document">
		<div class="modal-content" id="print-content">
			<div class="modal-header bg-light hide-print">
				<button type="button" class="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button>
				<h4 class="modal-title fs18" id="stockStoreDetailLabel">Depo No : {{ data.stockStore.id }}</h4>			
			</div>
	
			<div class="modal-body with-tab">
	
				<div class="loading" ng-if="loadingWork">
					<div id="global_loader" class="glb-ldr-prt"><div class="gl-ldr-cld"><div class="gl-ldr-ctr"><div class="gl-loader"></div></div></div></div>
				</div>
						
				<ul class="nav nav-tabs nav-justified" id="tabContent">
					<li class="active">
						<a target="_self" href="#stockStoreDetails" data-toggle="tab">Depo Detayları</a>
					</li>
					<li>
						<a target="_self" href="#stocks" data-toggle="tab">Stoklar</a>
					</li>
				</ul>

				<div class="tab-content">
					<div class="tab-pane active" id="stockStoreDetails">
						<div class="row mt15">
							<div class="col-md-12">
								<div class="panel mb10">
									<div class="panel-body mt10">
										<div class="col-md-6">
											<p>
												<strong>Depo Adı : </strong>
												<span>{{ data.stockStore.name }}</span>
											</p>
											<p>
												<strong>Açıklama : </strong>
												<span>{{ data.stockStore.description ? data.stockStore.description : '-' }}</span>
											</p>
											<p>
												<strong>Stok Sayısı : </strong>
												<span>{{ data.stockStore.stock_count }}</span>
											</p>
										</div>
										<div class="col-md-6">
											<p>
												<strong>Bağlı Olduğu Proje : </strong>
												<span>{{ data.stockStore.field_project ? data.stockStore.field_project.name : 'Yok' }}</span>
											</p>
											<p>
												<strong>Bağlı Olduğu Müşteri : </strong>
												<a href="#" ng-click="getCustomerDetails(data.stockStore.customer.id)" ng-if="data.stockStore.customer">{{ data.stockStore.customer.customer_name }}</a>
												<span ng-if="!data.stockStore.customer">Yok</span>
											</p>
											<p>
												<strong>Bağlı Olduğu Personel : </strong>
												<a href="#" ng-click="getWorkerDetails(data.stockStore.worker.id)" ng-if="data.stockStore.worker">{{ data.stockStore.worker.full_name }}</a>
												<span ng-if="!data.stockStore.worker">Yok</span>
											</p>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>

					<div class="tab-pane" id="stocks">
						<div class="row mt15">
							<div class="col-md-12">
								<div class="panel mb10">
									<table class="table table-hover tc-checkbox-1 fs13" ng-if="data.stockStore.stocks.length > 0">
										<thead>
											<tr class="bg-light">
												<th>
													<a href="#" ng-click="sortType = 'serial_number'; sortReverse = !sortReverse">
													Seri No 
													<span ng-show="sortType == 'serial_number' && !sortReverse" class="fa fa-caret-down"></span>
													<span ng-show="sortType == 'serial_number' && sortReverse" class="fa fa-caret-up"></span>
													</a>
												</th>
												<th>
													<a href="#" ng-click="sortType = 'name'; sortReverse = !sortReverse">
													Stok Adı
													<span ng-show="sortType == 'name' && !sortReverse" class="fa fa-caret-down"></span>
													<span ng-show="sortType == 'name' && sortReverse" class="fa fa-caret-up"></span>
													</a>
												</th>
												<th>
													<a href="#" ng-click="sortType = 'piece'; sortReverse = !sortReverse">
													Miktar
													<span ng-show="sortType == 'piece' && !sortReverse" class="fa fa-caret-down"></span>
													<span ng-show="sortType == 'piece' && sortReverse" class="fa fa-caret-up"></span>
													</a>
												</th>
											</tr>
										</thead>
										<tbody>
										<tr ng-repeat="item in data.stockStore.stocks | orderBy:sortType:sortReverse">
											<td class="clickable-row" ng-click="getStockDetail(item.id)">{{ item.serial_number ? item.serial_number : '-' }} </td>
											<td class="clickable-row" ng-click="getStockDetail(item.id)">{{ item.name ? item.name : '-' }} </td>
											<td class="clickable-row" ng-click="getStockDetail(item.id)">{{ item.piece +' '+ item.unit }} </td>
										</tr>
										</tbody>
									</table>

									<div ng-if="data.stockStore.stocks.length == 0">
										Bu depoya ait bir stok bulunmamaktadır.
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>


			<div class="modal-footer bg-light hide-print">
				<button type="button" class="btn btn-default" data-dismiss="modal">Kapat</button>
				<a href="stok/depo/{{ data.stockStore.id }}" class="btn btn-warning">Düzenle</a>
			</div>
		</div>
	</div>
</div>
<style>
	html, body {
	height: 100%;
	}
</style>